import React from 'react';
import { Briefcase, Home, Shield } from 'lucide-react';
import { Card } from './ui/card';

const iconMap = {
  briefcase: Briefcase,
  home: Home,
  shield: Shield
};

const ProductCategories = ({ categories }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(`category-${id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Our Product Range</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive solutions across professional, home, and security categories
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category) => {
            const Icon = iconMap[category.icon];
            return (
              <Card 
                key={category.id}
                onClick={() => scrollToSection(category.id)}
                className="group cursor-pointer border-2 border-gray-200 hover:border-black transition-all duration-300 overflow-hidden bg-white hover:shadow-xl"
              >
                <div className="p-8">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-black transition-colors duration-300">
                    <Icon className="text-black group-hover:text-white transition-colors duration-300" size={32} />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-black mb-3 group-hover:translate-x-1 transition-transform duration-300">
                    {category.name}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {category.description}
                  </p>

                  {/* Arrow Indicator */}
                  <div className="mt-6 flex items-center text-black font-medium group-hover:gap-2 transition-all duration-300">
                    <span>View Products</span>
                    <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                  </div>
                </div>

                {/* Decorative Element */}
                <div className="h-2 bg-gradient-to-r from-gray-200 to-gray-300 group-hover:from-black group-hover:to-gray-800 transition-all duration-300"></div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
